export enum SortBy {
  POPULAR,
  DISCOUNT,
  PRICE,
}
